import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  useTheme,
} from "@mui/material";
import { useDispatch, useSelector } from "../../store";
import { deleteJob, getJobById, reopenJob, resetJob } from "../../slices/job";
import {
  editAttachment,
  getAttachmentId,
  getJobAttachments,
  resetAttachment,
  setTempAttachments,
} from "../../slices/attachment";
import JobViewTop from "../views/JobDashboard/ReadOnlyView/JobViewTop";
import Attachment from "../../types/attachment";
import { Base } from "../base";
import { getJobTypeId, setCurrentViewJobType } from "../../slices/jobType";
import ConfirmDeleteForm from "../forms/ConfirmDeleteForm";
import { getAttachmentTypes } from "../../slices/attachmentType";

interface Props {}

const JobPage: React.FC<Props> = (props) => {
  const { job, status, getStatus } = useSelector((store) => store.job);
  const { jobAttachments } = useSelector((store) => store.attachments);
  const { currentViewJobType } = useSelector((store) => store.jobType);
  const theme = useTheme();
  const [deleteModal, setDeleteModal] = useState(false);
  const [reopenModal, setReopenModal] = useState(false);

  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(resetJob());
    dispatch(setTempAttachments([]));
    if (+(id ?? "") > 0) {
      dispatch(getJobById(+id!)).then(({ meta }) => {
        if (meta.requestStatus === "fulfilled") {
          dispatch(getJobAttachments(+id!));
        } else {
          navigate("/");
        }
      });
    }
    dispatch(getAttachmentTypes());
  }, [dispatch, id]);

  useEffect(() => {
    if (job.jobType) {
      dispatch(getJobTypeId(job.jobType.id!)).then(({ meta, payload }) => {
        if (meta.requestStatus === "fulfilled") {
          dispatch(setCurrentViewJobType(payload));
        }
      });
    }
  }, [job, dispatch]);

  const handleDownload = (id: number) => {
    dispatch(getAttachmentId(id)).then((result) => {
      let file = result.payload as Attachment;
      let a = document.createElement("a");
      a.href = file?.url!;
      a.download = file.name!;
      a.click();
      a.remove();
    });
  };

  const handleDeleteJob = () => {
    dispatch(deleteJob(job.id)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        navigate(`/home/${currentViewJobType?.id}`);
      }
    });
  };

  // const handleGetAttachment = (id: number) => {
  //   dispatch(getAttachmentId(id));
  // };

  // const handleEditAttachment = (v: Attachment) =>
  //   dispatch(editAttachment(v)).then(({ meta }) => {
  //     if (meta.requestStatus === "fulfilled") {
  //       dispatch(resetAttachment());
  //       dispatch(getJobAttachments(+id!));
  //     }
  //   });

  return (
    <>
      <Base.TitleBar title={job.jobNumber} />
      <Container maxWidth="xl">
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          sx={{
            backgroundColor: theme.palette.background.paper,
            padding: { md: 5, xs: 1 },
            borderRadius: "10px",
            marginY: { xs: 1, sm: 2 },
          }}
          rowGap={{ xs: 3 }}
          columnSpacing={3}
        >
          {getStatus === "loading" &&
          job.id !== +id! &&
          job.title === undefined ? (
            <Box>
              <Base.Text text="Loading, please wait..." variant="h3" />
              <CircularProgress />
            </Box>
          ) : (
            <>
              <JobViewTop
                setDeleteModal={setDeleteModal}
                reopenJob={() => setReopenModal(true)}
                handleDownload={handleDownload}
                attachments={jobAttachments}
                // getAttachment={handleGetAttachment}
                // handleEditAttachment={handleEditAttachment}
              />
            </>
          )}
        </Grid>
      </Container>
      <Base.Modal open={deleteModal} onClose={() => setDeleteModal(false)}>
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            width: 500,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <ConfirmDeleteForm
            handleCancel={() => setDeleteModal(false)}
            handleDelete={handleDeleteJob}
          />
        </Box>
      </Base.Modal>
      <Base.Dialog
        confirmButtonType="primary"
        confirmText="Reopen"
        title="Are you sure you would like to reopen this ticket? The original completed date will be removed, and it will need to be re-closed."
        loading={status === "loading"}
        open={reopenModal}
        handleCancel={() => setReopenModal(false)}
        handleConfirm={() =>
          dispatch(reopenJob(job.id)).then((result) => {
            if (result.meta.requestStatus === "fulfilled") {
              dispatch(getJobById(job.id));
              setReopenModal(false);
            }
          })
        }
      />
    </>
  );
};

export default JobPage;
